import { createListViewComponent } from 'factories/ListView'
import entityNames from 'options/entityNames'
import Filter from 'containers/Reports/InventoryReceivingAuditReport/Filter'

export default createListViewComponent({
  entityName: entityNames.inventoryReceivingAuditReport,
  filterTemplateType: 'InventoryReceivingAuditReport',
  initialFilterDto: (self) => ({ dateRange: { dateRangeType: 'YearToDate' } }),
  allowCreate: (self) => false,
  allowSelection: (self) => false,
})(Filter)
